import { createReducer } from './utils';
import { GET_MAP_METADATA_FILE, GET_MAP_METADATA_FILE_SUCCESS, GET_MAP_METADATA_FILE_FAILURE, SNACK_SET } from './constants';
import { handleRequest, handleAvailable, handleUnavailable } from '../reducerHandlers'

const defaultState = {
    loadingMapMetadata: false,
    mapMetadataUrl: null,
};

export const reducer = createReducer(defaultState, {
    [GET_MAP_METADATA_FILE]: handleRequest,
    [GET_MAP_METADATA_FILE_SUCCESS]: handleAvailable,
    [GET_MAP_METADATA_FILE_FAILURE]: handleUnavailable,
});


export function getMapMetadataFile(payload) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'mapMetadataUrl';
        const loadingName = 'loadingMapMetadata';

        dispatch({ type: GET_MAP_METADATA_FILE, payload: { loadingName } });

        try {
            const response = await dataSource.getMapMetadataFile(payload);
            dispatch({
                type: GET_MAP_METADATA_FILE_SUCCESS,
                payload: {
                    keyState,
                    data: response?.url || null,
                    loadingName,
                },
            });

        } catch (error) {
            dispatch({
                type: GET_MAP_METADATA_FILE_FAILURE,
                payload: {
                    keyState,
                    loadingName,
                    defaultState: null,
                },
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: "There was an error retrieving the map metadata file.",
                        severity: 'error',
                    },
                },
            });
        }
    };
}
